import React from 'react'
import { List } from 'react-admin'
import { ListActions } from '../../../components'

import MyList from '../list'

const Actions = (props) => {
  return <ListActions {...props} />
}

export const PrimeraDivisionList = (props) => (
  <List {...props} actions={<Actions />} bulkActions={false} bulkActionButtons={false} filter={{ section: 'app-homepage' }} title="App Homepage">
    <MyList />
  </List>
)

export default PrimeraDivisionList
